//axios
import axios from "axios";
import qs from "qs";
let axiosIns = axios.create({});

axiosIns.defaults.baseURL = "/api/";

console.log("process.env.NODE_ENV", process.env.NODE_ENV, axiosIns.defaults.baseURL);

axiosIns.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axiosIns.defaults.headers.get["X-Requested-With"] = "XMLHttpRequest";
axiosIns.defaults.responseType = "json";
axiosIns.defaults.transformRequest = [
	function(data) {
		return qs.stringify(data);
	}
];
axiosIns.defaults.validateStatus = function(status) {
	return true;
};
axiosIns.interceptors.request.use(function(config) {
	config.headers.Accept = "application/json";
	config.headers.System = "vue";
	if (window.instance.$store.state.isLogin) {
		config.headers.Token = window.instance.$store.state.userInfo.token;
	} else {
		window.instance.$store.commit("checkLogin");
		if (window.instance.$store.state.isLogin) {
			config.headers.Token = window.instance.$store.state.userInfo.token;
		}
	}
	return config;
});

axiosIns.interceptors.response.use(
	response => {
		let data = response.data;
		let status = response.status;

		if (status === 200 || status === 304) {
			if (response.request.responseType == "arraybuffer") {
				//下载文件请求
				return data;
			}
			let rstno = data.rstno;
			if (rstno > 0) {
				return data;
			} else {
				if (rstno === -401) {
					window.instance.$store.commit("doLogout");
					window.instance.$router.push({
						path: "/user/login",
						query: { redirect: window.instance.$route.fullPath }
					});
				}
				return Promise.reject(data);
			}
		} else {
			if (status === 412) {
				window.instance.$store.commit("doLogout");
				console.log(window.instance.$route.fullPath);
				window.instance.$router.push({
					path: "/user/login",
					query: { redirect: window.instance.$route.fullPath }
				});
			}
			window.instance.$emit("ajax_error", response.data);
			return Promise.reject({
				rstno: -10000,
				data: { msg: "网络错误", errInfo: response }
			});
		}
	},
	error => {
		return Promise.reject({
			rstno: -10000,
			data: { msg: "网络错误", errInfo: error }
		});
	}
);

let ajaxMethod = ["get", "post"];
let api = {
	// formPost: (uri, data, config) => {
	// 	return new Promise(function(resolve, reject) {
	// 		axiosIns[method](uri, data, config)
	// 			.then(json => {
	// 				resolve(json);
	// 			})
	// 			.catch(response => {
	// 				reject(response);
	// 			});
	// 	});
	// }
};
// ajaxMethod.forEach(method => {
// 	api[method] = function(uri, data, config) {
// 		return new Promise(function(resolve, reject) {
// 			axiosIns[method](uri, data, config)
// 				.then(json => {
// 					resolve(json);
// 				})
// 				.catch(response => {
// 					reject(response);
// 				});
// 		});
// 	};
// });

export default axiosIns;
